import { createContext } from "react";
import { AppState } from "../types/AppState";

export type State = {
  currentState: AppState;
  updateState: (newState: AppState) => void;
};

const state: State = {
  currentState: { status: "provide-file" },
  updateState: (newState) => {},
};

export const StateContext = createContext<State>(state);
